export default __webpack_public_path__ + "static/media/badge-1.536b2481.png";